'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_ju_List(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.bu)));
}
export { $is_ju_List as $is_ju_List };
function $isArrayOf_ju_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bu)));
}
export { $isArrayOf_ju_List as $isArrayOf_ju_List };
